import { makeStyles } from '@material-ui/core';
import { Colors, type LooseObject } from '@rentguru/commons-utils';
import { CSSProperties } from 'react';

export const useTextFieldStyles = makeStyles({
  label: {
    color: Colors.LIGHT_BLUE_GREY,
    overflowWrap: 'break-word',
  },
  underline: {
    '&:before': {
      borderBottom: `2px solid ${Colors.TOWER_GREY}`,
    },
  },
  select: {
    height: '1.1875em',
  },
  noEndArrow: {
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
    },
    '-moz-appearance': 'textfield',
  },
  cardFieldLabel: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: Colors.DARK_SLATE_GREY,
    marginBottom: 2,
  },
  outlinedRoot: {
    borderRadius: 8,
    minHeight: 46,
    alignItems: 'center',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: `${Colors.LIGHT_BLUE_GREY} !important`,
    },
  },
});

export interface TextDetailEditableProps {
  title: string;
  text?: string | null;
  editMode: boolean;
  name: string;
  error?: boolean;
  type?: string;
  // eslint-disable-next-line no-undef
  endAdornment?: string | JSX.Element;
  endAdornmentStyle?: React.CSSProperties;
  idInArray?: string;
  arrayName?: string;
  selectable?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectableValues?: any[];
  style?: React.CSSProperties;
  inputProps?: LooseObject;
  noMaxWidth?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeObserver?: (value: any) => void;
  disabled?: boolean;
  min?: number;
  max?: number;
  step?: number;
  helperText?: string;
  multiline?: boolean;
  rows?: string | number;
  rowsMax?: string | number;
  forcedValue?: string | number;
  typeNumberNoEndArrow?: boolean;
  titleStyle?: CSSProperties;
  useDefaultOnChange?: boolean;
  dataTest?: string;
  children?: React.ReactNode;
  placeholder?: string;
  modern?: boolean;
}
